import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section id="featured" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">
              精选重大事件
            </h2>
            <p className="text-sm text-foreground-600">
              编辑团队为你精选的最具影响力的历史事件深度解读
            </p>
          </div>
          <Link
            to="/category/politics"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap no-underline"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              summary={article.summary}
              category={article.category}
              categoryName={getCategoryName(article.category)}
              date={article.date}
              readTime={article.readTime}
              imageUrl={article.imageUrl}
              tags={article.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}